import { trim } from 'lodash';
import ZipFirstThreeToState from '../../../etc/zip_first_three_to_state.yml';

export const required = (id, value) => {
  if (!trim(value)) {
    return { [id]: 'Field is required' };
  }
  return { [id]: '' };
};

// Exported for tests
export const isStateZipCorrect = (state, zip) => {
  const stateConfig = ZipFirstThreeToState[state.toUpperCase()];
  if (!stateConfig) return false;

  if (stateConfig.invalid_full_zip?.includes(zip)) return false;
  if (stateConfig.valid_full_zip?.includes(zip)) return true;
  if (!stateConfig.valid_first_three) return false;

  const firstThree = zip.toString().substr(0, 3);
  return stateConfig.valid_first_three.includes(firstThree);
};

export const stateZipMatch = (stateId, stateValue, zipId, zipValue) => {
  if (isStateZipCorrect(stateValue, zipValue)) {
    return { [stateId]: '', [zipId]: '' };
  }
  return {
    [stateId]: 'State and zip must match.',
    [zipId]: 'State and zip must match.'
  };
};

export const allowedTextInput = (value, callback) => {
  if (value) {
    callback(value.match(/[!#$'*\-.{}@?:`\w\s]/g).join(''));
  } else {
    callback('');
  }
};

export const primaryAndSecondaryAddressValidator = (state) => {
  const streetAddress = state.homeStreetAddress || '';
  const cleanStreetAddress = streetAddress.trim().replace(/\s+/g, ' ');
  const secondaryAddress = state.secondaryAddress || '';
  const cleanSecondaryAddress = secondaryAddress.trim().replace(/\s+/g, ' ');

  if (!cleanSecondaryAddress) {
    return { secondaryAddress: '' };
  }

  // Some browsers will autofill the first line of an address into both the
  // Street Address and Address Line 2 fields. Prevent the user from submitting
  // when this happens
  const comparison = cleanStreetAddress.localeCompare(
    cleanSecondaryAddress,
    undefined,
    { sensitivity: 'accent' }
  );
  if (comparison === 0) {
    return {
      secondaryAddress: 'Street Address and Address Line 2 cannot be the same'
    };
  }

  return { secondaryAddress: '' };
};
